export default "__VITE_ASSET__DsTx7by6__"